module.exports = __webpack_public_path__ + "img/badge_gray_cap-careerplan.5d8a4341.svg";